import * as actions from '../actions/breachCausationCp';
import * as ActionTypes from '../actions/index';
import xs from 'xstream';
import BASE_URL from './variables';


export function getBreachCausationCp(sources) {

	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_BREACH_CAUSATION_CP)
		.map(action => ({
			url: BASE_URL + 'api/Applications/BreachCausationCpOptions' ,
			category: 'breachCausationCpOptions',
			method: 'GET',
			type: 'application/json',
			withCredentials: true
		}));

	//below httpResponse$ listens  for http responses and after filtering ,in order to get
	//the successful http get requests, it updates the redux store with the lawsys agents
	let httpResponse$ = sources.HTTP
		.select('breachCausationCpOptions')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => actions.receiveBreachCausationCp(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function failedBreachCausationCp(sources) {
	let httpResponse$ = sources.HTTP
		.select('breachCausationCpOptions')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 200)
		.map(response => actions.receiveBadRequestBreachCausationCp([]));

	return {
		ACTION: httpResponse$
	}
}